import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FilterListModule } from 'src/app/filterlist/filterlist.module';
import { AngularMaterialModule } from 'src/app/shared/module/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VehicleScheduleDetailComponent } from './vehicle-schedule-detail.component';
import { ApplicationPipesModule } from 'src/app/shared/module/applicationPipesModule';
import { PartTableAddModule } from '../part/component/part-table-add/part-table-add.module';
import { PartTableAvailModule } from '../part/component/part-table-avail/part-table-avail.module';
import { DynamicTableModule } from 'src/app/dynamic-table/dynamic-table.module';
import { AngularSplitModule } from 'angular-split';
import { TranslateModule } from '@ngx-translate/core';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [VehicleScheduleDetailComponent
  ],
  imports: [
    CommonModule,
    MatPaginatorModule,
    FilterListModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    ApplicationPipesModule,
    PartTableAddModule,
    PartTableAvailModule,
    DynamicTableModule,
    AngularSplitModule,
    TranslateModule,
    MatChipsModule,
  ]
})
export class VehicleScheduleDetailModule { }
